import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const RequestForm = () => {
  const history = useNavigate();

  const [formData, setFormData] = useState({
    requestId: 'LM-001',
    fullName: 'Arun Kumar',
    email: 'arun@gmail.com',
    phone: '9876543210',
    city: 'Chennai',
    requestFor: 'Match Making',
    status: 'Pending',
    requestDescription: 'I am looking for a suitable match with good family background and traditional values. Prefer someone from Chennai or nearby.'
  });

  const statusOptions = ['Pending', 'Approved', 'Rejected'];

  const handleStatusChange = (e) => {
    setFormData({
      ...formData,
      status: e.target.value
    });
  };

  const handleSave = () => {
    alert("Horoscope request status updated successfully");
  };

  const handleCancel = () => {
    history(`/agent/horoscope-req-list`);
  };

  return (
    <>
      <div className='container'>
        <div className="centerFruit" >
          <h2 class="font-great-vibes" style={{ margin: '0px 20px', color: '#B21919', }}>
            Edit Horoscope Request
          </h2>
          <div className="request-form-container">
            <div className="form-content">
              <div className="form-row">
                <div className="form-group">
                  <label>Request ID</label>
                  <input
                    type="text"
                    value={formData.requestId}
                    disabled
                    className="form-input disabled"
                  />
                </div>

                <div className="form-group">
                  <label>Status</label>
                  <select
                    value={formData.status}
                    onChange={handleStatusChange}
                    className="form-select"
                  >
                    {statusOptions.map(option => (
                      <option key={option} value={option}>{option}</option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Full Name</label>
                  <input
                    type="text"
                    value={formData.fullName}
                    disabled
                    className="form-input disabled"
                  />
                </div>

                <div className="form-group">
                  <label>Email</label>
                  <input
                    type="email"
                    value={formData.email}
                    disabled
                    className="form-input disabled"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Phone</label>
                  <input
                    type="text"
                    value={formData.phone}
                    disabled
                    className="form-input disabled"
                  />
                </div>

                <div className="form-group">
                  <label>City</label>
                  <input
                    type="text"
                    value={formData.city}
                    disabled
                    className="form-input disabled"
                  />
                </div>
              </div>

              <div className="form-group full-width">
                <label>
                  Request For <span className="required">*</span>
                </label>
                <input
                  type="text"
                  value={formData.requestFor}
                  disabled
                  className="form-input disabled"
                />
              </div>

              <div className="form-group full-width">
                <label>Request Description</label>
                <textarea
                  value={formData.requestDescription}
                  disabled
                  rows="4"
                  className="form-textarea disabled"
                />
              </div>

              <div className="form-actions">
                <button onClick={handleCancel} className="btn-cancel">
                  CANCEL
                </button>
                <button onClick={handleSave} className="btn-save">
                  SAVE CHANGES
                </button>
              </div>
            </div>
            <style jsx>
              {`
        .request-form-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 20px;
        }

        .form-content {
          width: 100%;
        }

        .form-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 20px;
          margin-bottom: 16px;
        }

        .form-group {
          display: flex;
          flex-direction: column;
        }

        .form-group.full-width {
          margin-bottom: 16px;
        }

        .form-group label {
          color: #666;
          font-size: 14px;
          font-weight: 500;
          margin-bottom: 8px;
          display: block;
        }

        .form-input,
        .form-select,
        .form-textarea {
          padding: 8px 12px;
          border: 1px solid #d9d9d9;
          border-radius: 4px;
          font-size: 16px;
          font-family: inherit;
          width: 100%;
          box-sizing: border-box;
        }

        .form-input:focus,
        .form-select:focus,
        .form-textarea:focus {
          outline: none;
          border-color: #5b5fc7;
          box-shadow: 0 0 0 2px rgba(91, 95, 199, 0.1);
        }

        .form-input.disabled,
        .form-textarea.disabled {
          background-color: #f5f5f5;
          color: #000;
          cursor: not-allowed;
        }

        .form-select {
          background-color: #fff;
          cursor: pointer;
          appearance: none;
          background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
          background-repeat: no-repeat;
          background-position: right 8px center;
          background-size: 16px;
          padding-right: 32px;
        }

        .form-textarea {
          resize: vertical;
          min-height: 100px;
        }

        .required {
          color: #ff4d4f;
          margin-left: 4px;
        }

        .form-actions {
          display: flex;
          gap: 12px;
          margin-top: 24px;
        }

        .form-actions button {
          height: 40px;
          padding: 0 24px;
          font-weight: 500;
          border-radius: 4px;
          border: none;
          cursor: pointer;
          font-size: 16px;
          transition: all 0.3s;
        }

        .btn-cancel {
          background-color: #fff;
          color: #333;
          border: 1px solid #d9d9d9;
        }

        .btn-save {
          background-color: #B21919;
          color: #fff;
        }

        /* Responsive */
        @media (max-width: 768px) {
          .form-row {
            grid-template-columns: 1fr;
          }
        }
        `}
            </style>
          </div>
        </div>
      </div>
    </>
  );
};

export default RequestForm;
